var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFedex = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 50,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5900",
    d: "m137.95 18 6.315 7.044L150.344 18h12.982l-12.687 14.441L163.5 47h-13.505l-6.256-7.1-6.198 7.1H124.5l12.748-14.499L124.5 18h13.45ZM124.5 17.163v10.081h-15.563v9.25H124.5V47h-27V0h27v10.476h-15.563v6.687H124.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A007C",
    d: "M86.414 0v19.35h-.123c-2.456-2.818-5.523-3.797-9.08-3.797-7.29 0-12.783 4.95-14.71 11.49-2.2-7.207-7.87-11.626-16.277-11.626-6.828 0-12.22 3.06-15.032 8.044v-6.195H17.079v-6.727H32.48V0H4.5v47.28h12.58V27.408h12.539a18.806 18.806 0 0 0-.575 4.674c0 9.861 7.549 16.783 17.18 16.783 8.1 0 13.438-3.796 16.26-10.716H51.701c-1.457 2.081-2.563 2.697-5.478 2.697-3.38 0-6.296-2.944-6.296-6.434H61.88C62.833 42.244 68.946 49 77.332 49c3.619 0 6.932-1.777 8.957-4.776h.123v3.061H97.5V0H86.414ZM40.28 27.547c.699-3.004 3.033-4.965 5.946-4.965 3.206 0 5.42 1.901 6.004 4.965H40.28Zm39.402 12.536c-4.087 0-6.629-3.803-6.629-7.773 0-4.243 2.21-8.324 6.63-8.324 4.581 0 6.406 4.08 6.406 8.324 0 4.023-1.934 7.773-6.407 7.773Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFedex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fedex.5571e772e165e3b4aba554bf92a4a2d6.svg";